import { Avatar, Box, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Oval } from 'react-loader-spinner';

import { flexMixin } from 'utils/flexMixin';

import { NamespacesList } from 'core/enums/common';
import { FoundUser, UserFile } from 'core/types/base';

import { Owner, OwnerInfo } from 'components/Profile/Documents/styled';

import * as Styled from './styled';

interface UserDetailsProps {
	user: any;
	giveAccess?: (user: FoundUser) => void;
	removeAccess?: (user: FoundUser) => void;
	haveSuccess: boolean;
	currentFile?: UserFile | null;
}

const renderActionButton = (
	onClickHandler: () => void,
	buttonText: string,
	isLoading?: boolean,
	isAccess?: boolean
) => (
	<Styled.RemoveAccessButton
		onClick={onClickHandler}
		disabled={isLoading}
		sx={{
			color: isAccess ? 'rgb(71, 134, 255)' : 'rgb(251, 11, 36)',
		}}
	>
		{isLoading ? (
			<Box sx={{ ...flexMixin({ gap: 8 }) }}>
				<Oval
					height={24}
					width={24}
					color="rgba(0, 0, 0, 0.26)"
					wrapperStyle={{}}
					wrapperClass=""
					visible={true}
					ariaLabel="oval-loading"
					secondaryColor="rgba(0, 0, 0, 0.26)"
					strokeWidth={5}
					strokeWidthSecondary={5}
				/>
				{buttonText}
			</Box>
		) : (
			buttonText
		)}
	</Styled.RemoveAccessButton>
);

export const UserDetails: FC<UserDetailsProps> = ({
	user,
	giveAccess,
	removeAccess,
	haveSuccess,
	currentFile,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const handleRemoveAccess = async () => {
		setIsLoading(true);
		await removeAccess?.(user);
		setIsLoading(false);
	};

	const handleGiveAccess = async () => {
		setIsLoading(true);
		await giveAccess?.(user);
		setIsLoading(false);
	};

	return (
		<Styled.ModalUser key={`${user.firstName} ${user.lastName}`}>
			<Owner>
				<Avatar sx={{ bgcolor: '#1976d2' }} src={user?.avatarLink || ''}>
					{!user?.avatarLink && `${user?.firstName[0]}${user?.lastName[0]}`}
				</Avatar>
				<OwnerInfo>
					<Typography variant="h4">
						{user?.firstName} {user?.lastName}
					</Typography>
					<Typography>{user?.email}</Typography>
				</OwnerInfo>
			</Owner>
			{currentFile?.userId === user.id || user.userId ? (
				<Styled.OwnerLabel>{modalTranslate('allowAccessModal.isOwner')}</Styled.OwnerLabel>
			) : haveSuccess ? (
				renderActionButton(
					handleRemoveAccess,
					modalTranslate('allowAccessModal.removeAccess'),
					isLoading,
					false
				)
			) : (
				renderActionButton(
					handleGiveAccess,
					modalTranslate('allowAccessModal.giveAccess'),
					isLoading,
					true
				)
			)}
		</Styled.ModalUser>
	);
};
